import React from 'react'
import { Link } from 'react-router-dom'
import wad from '../../../../assets/img/wad_mn.webp'
import './Wadhead.css'
import ContactForm from '../../Contact/ContactForm'

function Wadhead() {
  return (
    <section className='hmslder-sec serhead-sec'>
        <div className='breadcrumbs'>
            <div className='container'>
             <ul>
               <li><Link to='/'>Home</Link></li> 
               <li><Link to='/Service'>Services</Link></li>  
               <li>Web Application Development</li>   
             </ul> 
             </div> 
        </div>
        <div className='container'>
           <div className='hmslder-txt'>
              <h2>Your Partner in <span>Web Application</span> Development</h2>
              <p>At 360 Bytes, we specialize in creating cutting-edge web applications tailored to meet your business needs. Our expert team leverages the latest technologies to deliver robust, scalable, and user-friendly solutions. Whether you're looking to streamline operations, enhance user engagement, or drive innovation, 360 Bytes is your trusted partner in web application development. Let us transform your vision into reality with precision and excellence.</p>
            </div> 
           
             <ContactForm/>
            {/* <img src={wad} alt='Web Application Development' width={1200} height={800} loading="lazy" /> */}
          
        </div>
    </section>
  )
}

export default Wadhead
